import axios from 'axios';
import config from '@/config';
import { buildAxiosGetConfigWithRepeatedKey } from '@/features/common/utils/axiosQueryUtil';

const { iffApi } = config.ctx;

/**
 * 任务管理API服务
 */
export const taskService = {
  /** 分页查询任务组 */
  queryTaskGroupPage: (params) => axios.get(`${iffApi}/task/group/page`, { params: params }),

  /** 任务组详情（含 dayAutoCreate 等） */
  getTaskGroup: (uuid) => axios.get(`${iffApi}/task/group/detail/${uuid}`),

  /** 创建任务组 */
  createTaskGroup: (data) => axios.post(`${iffApi}/task/group/create`, data),

  /** 预览任务组 */
  previewTaskGroup: (data) => axios.post(`${iffApi}/task/group/preview`, data),

  /** 更新任务组名称 */
  updateTaskGroup: (data) => axios.post(`${iffApi}/task/group/update`, data),

  /** 删除任务组 */
  deleteTaskGroup: (uuid) => axios.delete(`${iffApi}/task/group/delete/${uuid}`),

  // ========== 子任务 ==========

  /** 查询子任务列表（不分页，用于任务组页嵌套） */
  listTasks: (params) => axios.get(`${iffApi}/task/task/list`, { params: params }),

  /** 分页查询子任务列表（statusList 多值时重复 query 参数 statusList=） */
  queryTaskPage: (inputParams = {}) =>
    axios.get(`${iffApi}/task/task/page`, buildAxiosGetConfigWithRepeatedKey(inputParams, 'statusList')),

  /** 新增子任务 */
  saveTask: (data) => axios.post(`${iffApi}/task/task/save`, data),

  /** 编辑子任务 */
  updateTask: (data) => axios.post(`${iffApi}/task/task/update`, data),

  /** 删除子任务 */
  deleteTask: (uuid) => axios.delete(`${iffApi}/task/task/delete/${uuid}`),

  /** 手动创建今日每日任务（仅指定任务组） */
  createTodayTasks: (groupId) => axios.post(`${iffApi}/task/task/createToday/${groupId}`),

  // ========== 任务明细 ==========

  /** 分页查询任务明细 */
  queryTaskDetailPage: (params) => axios.get(`${iffApi}/task/detail/page`, { params: params }),

  // ========== 人员分配 ==========

  /**
   * 期次整体改派（同时更新该期次内所有子任务的分配字段）
   * @param {Object} data { groupId, periodName, assignType, assignUserIds, assignTeamId }
   */
  reassignPeriod: (data) => axios.post(`${iffApi}/task/task/reassignPeriod`, data)
};
